import { Api } from "@core/api/api";
import { Page, PaginationOptions } from "@utils/page";
import { Tag } from "./dtos";

const TAGS_URL = "/tags";

export class TagsApi {
	constructor(private readonly api: Api) {}

	async getTag(id: string): Promise<Tag> {
		const result = await this.api.get<Tag>(`${TAGS_URL}/${id}`);
		return result.data;
	}

	async suggestByValue(_pageOptions: PaginationOptions, query: string): Promise<Page<Tag>> {
		const result = await this.api.get<Page<Tag>>(`${TAGS_URL}?query=${query}`);
		return result.data;
	}
}
